import moment from "moment";

const FILE_PDF = 18;

/**
 * Determines if a file should open in a new tab on Apple devices
 *
 * @param {number} typeID - The type ID of the file
 * @returns {boolean} - Returns true if the file should open in a new tab
 */
export const aAppledeviceBlankTarget = (typeID) => {
  return [FILE_PDF].includes(typeID);
};

/**
 * Gets the current UTC date
 *
 * @returns {Date} - Returns a new Date object set to the current UTC date and time
 */
export const getCurrentUTCDate = () => {
  const now = new Date();
  return new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
  );
};

/**
 * Determines item class and tooltip based on publish status
 *
 * @param {Object} item - The item to check publish status for
 * @param {Date} utcDate - The current UTC date to compare against
 * @param {Function} languageContext - Function to get localized strings
 * @returns {Object} - Returns object with itemClass and tooltip properties
 * @property {string} itemClass - CSS classes to apply to the item
 * @property {string} tooltip - Tooltip text to display for the item
 */
export const getItemStatusInfo = (item, utcDate, languageContext) => {
  let itemClass = "";
  let tooltip = item.hint ? item.hint : item.title;

  const localPublishStart = moment.utc(item.publishStart).toDate();
  const localPublishStop = moment.utc(item.publishStop).toDate();

  const isDisabled = !item.enabled;
  const isBeforePublishStart =
    item.publishStart && moment(item.publishStart).isAfter(utcDate);
  const isAfterPublishStop =
    item.publishStop &&
    moment(item.publishStop).isBefore(utcDate) &&
    item.publishStopEnabled;

  const getStatusText = () => {
    if (isDisabled) {
      return languageContext("nodenotvisible");
    }
    if (isBeforePublishStart) {
      return `${languageContext("publishStart")} ${moment(localPublishStart).format("YYYY-MM-DD HH:mm")}`;
    }
    if (isAfterPublishStop) {
      return `${languageContext("publishStop")} ${moment(localPublishStop).format("YYYY-MM-DD HH:mm")}`;
    }
    return null;
  };

  const statusText = getStatusText();
  if (statusText) {
    itemClass += " italic";
    tooltip += ` (${statusText})`;
  }

  return { itemClass, tooltip };
};
